import { appApi } from '../api';

export const appRepo = {
    getOverview: (params) => appApi.getOverview(params),

    getOwnerDashboard: (params) => appApi.getOwnerDashboard(params),

    getSellerDashboard: (params) => appApi.getSellerDashboard(params),
};